import React from 'react';
import { Button, ButtonProps } from '../ui/button';
import { cn } from '../ui/lib/utils';
import { Loader2 } from 'lucide-react';

type ButtonModes = 'v1' | 'v2';
interface IButtonContainedProps extends ButtonProps {
  mode?: ButtonModes;
}

const buttonStyles = {
  v1: 'bg-gradient-to-tr from-[#0f1fd0] via-[#7110e4] via-[#6f10e4] to-[#c403f6] hover:opacity-[0.9] gap-[2px] text-white',
  v2: 'flex-1 p-[1px] rounded-[6px] bg-gradient-to-r from-[#0f1fd0] to-[#c403f6] hover:bg-[#312f39] text-white',
};

const ButtonContained: React.FC<IButtonContainedProps> = (props: IButtonContainedProps) => {
  const { children, className, mode = 'v1', loading } = props;
  return (
    <Button
      {...props}
      disabled={props?.disabled || loading}
      className={cn([buttonStyles[mode], className])}
    >
      {mode === 'v2' ? (
        <div className="bg-black rounded-[6px] h-[100%] w-full hover:opacity-[0.9] flex items-center justify-center px-[10px]">
          {loading && <Loader2 className={cn('h-4 w-4 animate-spin', children && 'mr-2')} />}
          {children}
        </div>
      ) : (
        <>
          {loading && <Loader2 className={cn('h-4 w-4 animate-spin', children && 'mr-2')} />}
          {children}
        </>
      )}
    </Button>
  );
};

export default ButtonContained;
